import { QueryClient, useQuery } from 'react-query';
import { listTutorialVideosQuery } from '../api/queries';

const key = 'tutorial-videos';

const fetchVideos = async () => {
  try {
    const videos = await listTutorialVideosQuery();

    return videos;
  } catch (ex: unknown) {
    return [];
  }
};

export const useTutorialVideos = () => {
  return useQuery(key, fetchVideos);
};

export const prefetchTutorialVideo = (client: QueryClient) =>
  client.prefetchQuery(key, fetchVideos);
